// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3tkqj","productName":"Table_productName__187sJ"};